/**
 * GymDisclaimer — Liability disclaimer shown on gym leaderboards.
 * Required for V1 to protect against trademark/affiliation claims.
 */
import { View, Text, StyleSheet } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';
import { FONT, SPACE } from '@/constants/designTokens';
import { Info } from 'lucide-react-native';

interface GymDisclaimerProps {
  gymName?: string;
}

export default function GymDisclaimer({ gymName }: GymDisclaimerProps) {
  const { theme } = useTheme();
  const c = theme.colors;

  return (
    <View style={[styles.container, { backgroundColor: c.surfaceVariant, borderColor: c.border }]}>
      <Info size={12} color={c.textTertiary} />
      <Text style={[styles.text, { color: c.textTertiary }]}>
        {gymName
          ? `This location is user-created and not affiliated with ${gymName}.`
          : 'Gym locations are user-created and not affiliated with or endorsed by the venue.'}
        {' '}Rankings are based on self-reported data.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 6,
    padding: SPACE.sm,
    borderWidth: 1,
    borderRadius: 2,
  },
  text: {
    flex: 1,
    fontSize: 11,
    lineHeight: 14,
  },
});
